import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("../views/login/index.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        path: "/home",
        name: "Welcome",
        meta: {
          title: "首页",
        },
        component: () => import("../views/welcome.vue"),
      },
      {
        path: "/dataStatistics",
        name: "dataStatistics",
        redirect: "/dataStatistics/statistics",
        meta: {
          title: "数据统计",
        },
        component: () => import("../views/dataStatistics/index.vue"),
        children: [
          {
            path: "/dataStatistics/statistics",
            name: "statistics",
            meta: {
              title: "数据统计",
            },
            component: () => import("../views/dataStatistics/statistics.vue"),
          },
        ],
      },
      {
        path: "/dataStatistics",
        name: "dataStatistics",
        redirect: "/dataStatistics/statistics",
        meta: {
          title: "数据统计",
        },
        component: () => import("../views/dataStatistics/index.vue"),
        children: [
          {
            path: "/dataStatistics/statistics",
            name: "statistics",
            meta: {
              title: "数据统计",
            },
            component: () => import("../views/dataStatistics/statistics.vue"),
          },
        ],
      },
      {
        path: "/carManagement",
        name: "carManagement",
        redirect: "/carManagement/carList",
        meta: {
          title: "车辆管理",
        },
        component: () => import("../views/carManagement/index.vue"),
        children: [
          {
            path: "/carManagement/carList",
            name: "carList",
            meta: {
              title: "车辆列表",
            },
            component: () => import("../views/carManagement/carList.vue"),
          },
        ],
      },
      {
        path: "/testerManagement",
        name: "testerManagement",
        redirect: "/testerManagement/testerList",
        meta: {
          title: "试验员管理",
        },
        component: () => import("../views/testerManagement/index.vue"),
        children: [
          {
            path: "/testerManagement/testerList",
            name: "testerList",
            meta: {
              title: "试验员列表",
            },
            component: () => import("../views/testerManagement/testerList.vue"),
          },
          {
            path: "/testerManagement/publish",
            name: "publish",
            meta: {
              title: "试验员",
            },
            component: () => import("../views/testerManagement/publish.vue"),
          },
        ],
      },
      {
        path: "/testTaskManagement",
        name: "testTaskManagement",
        redirect: "/testTaskManagement/testTaskList",
        meta: {
          title: "试验任务管理",
        },
        component: () => import("../views/testTaskManagement/index.vue"),
        children: [
          {
            path: "/testTaskManagement/testTaskList",
            name: "testTaskList",
            meta: {
              title: "试验任务",
            },
            component: () => import("../views/testTaskManagement/testTaskList.vue"),
          },
          {
            path: "/testTaskManagement/testTaskDetail",
            name: "testTaskDetail",
            meta: {
              title: "试验任务详情",
            },
            component: () => import("../views/testTaskManagement/testTaskDetail.vue"),
          },
        ],
      },
      {
        path: "/systemManagement",
        name: "systemManagement",
        redirect: "/systemManagement/roleList",
        meta: {
          title: "系统管理",
        },
        component: () => import("../views/systemManagement/index.vue"),
        children: [
          {
            path: "/systemManagement/roleList",
            name: "roleList",
            meta: {
              title: "角色列表",
            },
            component: () => import("../views/systemManagement/roleList.vue"),
          },
          {
            path: "/systemManagement/userList",
            name: "userList",
            meta: {
              title: "用户列表",
            },
            component: () => import("../views/systemManagement/userList.vue"),
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | 考试系统`;
  next();
});

export default router;
